import React, { useMemo } from "react";
import { Button, SxProps, useTheme } from "@mui/material";
import Typography from "@common/components/Typography";
import {
  getCurrentSizeProfile,
  responsiveFontSize,
} from "@common/components/Typography/style";

interface TicketStatusProps {
  priority: TicketsPriorityFilter;
  id: string;
  onClick?: (id: string) => void;
  bordered?: boolean;
}

const TicketStatus = (props: React.PropsWithChildren<TicketStatusProps>) => {
  const { priority, id, onClick = () => {}, bordered = false } = props;
  const theme = useTheme();
  const btnSx: SxProps = bordered ? { border: "2px solid white" } : {};

  const ButtonComputeStyle = useMemo(() => {
    return {
      "&.MuiButtonBase-root": {
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: theme.palette.ticket[priority].main,
        width: "fit-content",
        fontSize: getCurrentSizeProfile().small,
        ...responsiveFontSize(theme, "small"),
        padding: "0.5em",
        borderRadius: "8px",
        lineHeight: 1,
      },
    };
  }, [theme, priority]);

  return (
    <Button
      onClick={() => onClick(id)}
      sx={[ButtonComputeStyle, btnSx]}
      variant="outlined"
    >
      <Typography
        variant="caption"
        sx={(theme) => ({
          "&.MuiTypography-root": {
            lineHeight: 1,
            color: theme.palette.common.white,
          },
        })}
      >
        {id}
      </Typography>
    </Button>
  );
};

export default TicketStatus;
